/**
 * LanguageHead Component
 * Manages dynamic HTML lang attribute and document meta tags based on current language
 */

import { useEffect } from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const LanguageHead = () => {
  const { currentLanguage, t } = useLanguage();

  useEffect(() => {
    // Update HTML lang attribute (English only)
    document.documentElement.lang = 'en';

    // Update meta description
    const metaDescription = 'Copilote AI Business - AI-Powered Business Management Platform for Freelancers and SMBs. Smart invoicing, automated workflows, and growth tools.';

    const metaDescriptionTag = document.querySelector('meta[name="description"]');
    if (metaDescriptionTag) {
      metaDescriptionTag.setAttribute('content', metaDescription);
    }

    // Update OG meta tags
    const ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription) {
      ogDescription.setAttribute('content', metaDescription);
    }

    // Update page title
    document.title = 'Copilote AI Business - AI-Powered Business Management Platform';

    // Log for debugging
    console.log('🌍 Language head updated: English');
  }, []);

  return null; // This component doesn't render anything
};

export default LanguageHead;
